"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.evaluateAgoraNetworkQuality = evaluateAgoraNetworkQuality;
exports.isChromiumBased = isChromiumBased;
exports.isMobileDevice = isMobileDevice;
function isChromiumBased() {
  var userAgent = navigator.userAgent;
  var isChromium = userAgent.includes('Chrome') || userAgent.includes('Chromium') || userAgent.includes('Edg');
  return isChromium;
}
function isMobileDevice() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // List mobile user agents
  var mobileDevices = [/android/i, /webos/i, /iphone/i, /ipad/i, /ipod/i, /blackberry/i, /windows phone/i];
  for (var _i = 0, _mobileDevices = mobileDevices; _i < _mobileDevices.length; _i++) {
    var device = _mobileDevices[_i];
    if (userAgent.match(device)) {
      return true;
    }
  }
  return false;
}

/**
 * Evaluates Agora network quality scores to determine whether a connection was established.
 *
 * Network quality scores range from 0–6:
 * - 1: Excellent, 2: Good, 3: Poor, 4: Bad, 5: Very Bad, 6: Disconnected, 0: Unknown
 *
 * isConnected: true when both scores are 1–5 (a connection was established, regardless of quality).
 * Scores of 0 (unknown) or 6 (disconnected) mean the client never successfully connected.
 *
 * @param {Object} result - The Agora sandbox meeting result object
 * @param {Object} result.networkQuality - The network quality scores
 * @param {number} result.networkQuality.uplinkNetworkQuality - Uplink quality score (0–6)
 * @param {number} result.networkQuality.downlinkNetworkQuality - Downlink quality score (0–6)
 * @returns {{ uplinkNetworkQuality: number, downlinkNetworkQuality: number, isConnected: boolean }}
 */
function evaluateAgoraNetworkQuality(result) {
  var _result$networkQualit = result.networkQuality,
    uplinkNetworkQuality = _result$networkQualit.uplinkNetworkQuality,
    downlinkNetworkQuality = _result$networkQualit.downlinkNetworkQuality;
  var isConnected = uplinkNetworkQuality >= 1 && uplinkNetworkQuality <= 5 && downlinkNetworkQuality >= 1 && downlinkNetworkQuality <= 5;
  return {
    uplinkNetworkQuality: uplinkNetworkQuality,
    downlinkNetworkQuality: downlinkNetworkQuality,
    isConnected: isConnected
  };
}